module.exports = __webpack_public_path__ + "static/media/dot-circle.320c1993.svg";